interface Props {
  className?: string;
}

const PromotionFillIcon = ({ className }: Props) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 -960 960 960">
    <path d="M856-390 570-104q-12 12-27 18t-30 6-30-6-27-18L103-457q-11-11-17-25.5T80-513v-287q0-33 23.5-56.5T160-880h287q16 0 31 6.5t26 17.5l352 353q12 12 17.5 27t5.5 30-5.5 29.5T856-390M260-640q25 0 42.5-17.5T320-700t-17.5-42.5T260-760t-42.5 17.5T200-700t17.5 42.5T260-640"></path>
  </svg>
);

export default PromotionFillIcon;
